export const NAVBAR_HEIGHT = 73;
export const LOGO_TOOLBAR_WIDTH = 24;
export const LOGO_TOOLBAR_HEIGHT = 24;
export const AVATAR_WIDTH = 24;
export const AVATAR_HEIGHT = 24;

const scope = 'app/containers/NavigationBar/';
export const SET_LOADING_FLAG = `${scope}SET_LOADING_FLAG`;
